import type { UserProfile } from '../auth/OfficeAuthProvider'

/**
 * Pane header — only rendered when signed in.
 *
 * Agent name on top, then the signed-in user with their department in brackets.
 * BOL2's /api/v1/me returns no role display name (the JWT carries role *keys* such
 * as `SI:admin`, whose labels live in `look_up_roles.role_name`), so `department` is
 * the human-readable label available without extending that endpoint.
 */
export function Header({ profile, onSignOut }: { profile: UserProfile; onSignOut: () => void }) {
    return (
        <header className="flex flex-none items-center gap-2 border-b border-border bg-card px-2.5 py-2">
            <div className="min-w-0">
                <div className="truncate text-xs font-semibold">{profile.agentName}</div>
                <div className="truncate text-[10.5px] text-foreground/55">
                    {profile.name}
                    {profile.department ? ` (${profile.department})` : ''}
                </div>
            </div>
            <button
                type="button"
                onClick={onSignOut}
                title={`Sign out ${profile.name}`}
                aria-label={`Sign out ${profile.name}`}
                className="ml-auto grid size-6 flex-none place-items-center rounded-full bg-secondary text-[9.5px] font-bold text-secondary-foreground"
            >
                {profile.initials}
            </button>
        </header>
    )
}
